import { ref, watch, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useIssueBoxesList() {
    const toast = useToast()
    const records = ref(null)
    const isBusy = ref(false)

    // Table Handler
    const columns = [
        { key: 'number', label: 'GRN/SIN #', sortable: true, searchable: true },
        { key: 'type', label: 'Type', sortable: false, searchable: false },
        { key: 'quantity', label: 'Quantity', sortable: false, searchable: false },
        { key: 'actual', label: 'Actual', sortable: false, searchable: false },
        { key: 'from', label: 'Source', sortable: false, searchable: false },
        { key: 'to', label: 'Destination', sortable: false, searchable: false },
        { key: 'received', label: 'Status', sortable: false, searchable: false },
        { key: 'items', label: 'Items', sortable: false, searchable: false },
        { key: 'offloaded', label: 'Received', sortable: false, searchable: false },
        'actions',
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('updated_at')
    const isSortDirDesc = ref(true)
    const locationFilter = ref(null)
    const locationType = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([locationFilter, currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        isBusy.value = true
        store.dispatch('cromis-issue-box/list', {
            location_id: locationFilter.value,
            query: searchQuery.value,
            per_page: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            isBusy.value = false
            const { ledgers, meta } = response.data

            meta.value = meta

            callback(ledgers)
            totalRecords.value = meta.value.total
            from.value = meta.value.from
            to.value = meta.value.to
        })
        .catch(() => {
            isBusy.value = false
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching inventory movement list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = status => {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
        isBusy,
    
        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,
    
        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
        locationFilter,
    }
}
